var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assunto da Notificação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.assunto,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "assunto", $$v);
      },
      expression: "form.filters.assunto"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFinal,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFinal", $$v);
      },
      expression: "form.filters.dataFinal"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.form.lists.grupos,
      "item-text": "nome",
      "item-value": "id",
      "label": "Grupo",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.grupoId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "grupoId", $$v);
      },
      expression: "form.filters.grupoId"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarGrupoNotificacoes();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterGrupoNotificacao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "expanded": _vm.expanded,
      "show-expand": ""
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.assunto`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.assunto) + " ")];
      }
    }, {
      key: `item.dataNotificacaoStr`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.dataNotificacaoStr) + " ")];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref3) {
        var headers = _ref3.headers,
          item = _ref3.item;
        return [_c('td', {
          staticClass: "grupos",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.grupos, function (grupo, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_c('v-icon', {
            staticClass: "grupo",
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(grupo.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar Notificação",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarGrupoNotificacao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Reenviar Notificação",
            "icon": "mdi-plus-circle-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterGrupoNotificacao(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogVisualizarGrupoNoficicacao.visible ? _c('VisualizarGrupoNotificacaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarGrupoNoficicacao.visible,
      "content": _vm.dialogVisualizarGrupoNoficicacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarGrupoNoficicacao.close();
      }
    }
  }) : _vm._e(), _c('AdicionarGrupoNotificacaoDialog', {
    attrs: {
      "edit": _vm.dialogManterGrupoNoficicacao.edit,
      "visible": _vm.dialogManterGrupoNoficicacao.visible,
      "content": _vm.dialogManterGrupoNoficicacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterGrupoNoficicacao.close();
      },
      "onSave": function ($event) {
        return _vm.buscarGrupoNotificacoes();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }